var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLawnMower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "n16zdpdhaa",
    d: "M0.245 0.785L25.342 0.785 25.342 22.5 0.245 22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9k5bt748sc",
    d: "M0 0.131L10.633 0.131 10.633 11.161 0 11.161z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCF040",
    d: "M17.17 13.762l4.585 1.375c.48.144.987-.128 1.13-.608.145-.48-.128-.986-.608-1.13l-4.586-1.376c-.48-.144-.986.13-1.131.609-.144.48.129.986.61 1.13",
    transform: "translate(0 .163)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .163) translate(1.8 .115)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6arga5dkmb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n16zdpdhaa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#91D9BF",
    d: "M23.977 18.226c-.142-.872-.768-1.604-1.636-1.865l-9.384-2.825c-.501-.151-1.003-.125-1.45.033L1.17.976C.99.753.66.721.436.902c-.222.182-.256.51-.074.733l10.26 12.497c-.328.33-.562.758-.646 1.245l-.038-.001c-1.968 0-3.564 1.594-3.564 3.562 0 1.967 1.596 3.562 3.564 3.562 1.155 0 2.178-.55 2.83-1.401h8.284c.328.82 1.128 1.401 2.066 1.401 1.228 0 2.225-.995 2.225-2.223 0-.923-.564-1.715-1.366-2.051M9.938 19.888c-.524 0-.951-.426-.951-.95 0-.525.427-.951.951-.951.526 0 .952.426.952.95 0 .525-.426.951-.952.951m13.18.916c-.292 0-.528-.235-.528-.527 0-.292.236-.528.528-.528.291 0 .528.236.528.528 0 .292-.237.527-.528.527",
    mask: "url(#6arga5dkmb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .163) translate(0 8.215)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zee6c0dc2d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9k5bt748sc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CCF040",
    d: "M7.653 10.837c0-1.868 1.262-3.446 2.98-3.93L5.5.72C4.35-.33 2.506.078 1.908 1.516L.193 6.443c-.594 1.425.238 3.042 1.742 3.39l5.734 1.328c-.008-.107-.016-.215-.016-.324",
    mask: "url(#zee6c0dc2d)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawnMower);
export default __webpack_public_path__ + "static/media/LawnMower.28ac51546addb440cb75e1ee856c9035.svg";
export { ForwardRef as ReactComponent };